export default "__VITE_ASSET__c8cf7b53__"